import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, IRoleGuarded, ClaimValues } from '@mt-ng2/auth-module';
import { ClaimTypes } from '../model/ClaimTypes';
import { PickupPaymentDetailsListComponent } from './pickup-payment-details-list/pickup-payment-details-list.component';
import { PendingTransactionsListComponent } from './pending-transactions-list/pending-transactions-list.component';

const roleGuard: IRoleGuarded = {
    claimType: ClaimTypes.PickupPaymentDetails | ClaimTypes.PendingTransaction,
    claimValues: [ClaimValues.ReadOnly, ClaimValues.FullAccess],
};

const routes: Routes = [
    { path: 'payments-transactions-history', component: PickupPaymentDetailsListComponent, canActivate: [AuthGuard], data: roleGuard },
    { path: 'pending-transactions', component: PendingTransactionsListComponent, canActivate: [AuthGuard], data: roleGuard },
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)],
})
export class PickupPaymentDetailRoutingModule {}
